import React from 'react'
import {Link} from 'react-router-dom'

const Navbar = () =>{
    return(
 <nav className="navbar navbar-dark bg-dark mb-5">
  <span className="navbar-brand mb-0 h1">TechNewsPlus</span>
<Link to ="/about">
  <li className="nav-link text-white">About</li>
  </Link>
  </nav>
    )
}
export default Navbar